<div class="Spinner" *ngIf="isLoading"><mat-spinner></mat-spinner></div>
<section *ngIf="!isLoading" class="section-banner-service">
  <div [ngClass]="styleBanners" class="bannerBackground">
    <div class="img-banner">
      <img src="{{ imagen_banner }}" />
    </div>

    <div class="text-banner">
      <h1 *ngIf="bannerManagementStrong !== 5 && bannerManagementStrong !== 7"> <strong>
        {{ "ManageMaintenance" | translate }}</strong>
      </h1> 
      <h1 *ngIf="bannerManagementStrong === 5 || bannerManagementStrong === 7"> 
        {{ "ManageMaintenance" | translate }}
      </h1>
     
      <p>
        {{ "ManageMaintenanceText" | translate }}
      </p>
    </div>
  </div>
  <div class="section-op-select">
    <div class="container-select-diary">
      <div class="header-card-op">
        <i class="bi bi-calendar2-check" style="font-size: 40px"></i>

        <div class="text-op">
          <h3>{{ "Schedule" | translate }}</h3>
          <p>{{ "YourDate" | translate }}</p>
        </div>
      </div>
      <div class="banner-content-card">
        <div class="text-description-op">
          <p>{{ "TextScheduleYourDate" | translate }}</p>
        </div>
        <a
          [routerLink]="scheduleAppointment"
          [state]="{
            brand: indexbrand,
            country: indexCountry,
            LanguageForCountry: LanguageForCountry,
            tokenIncadea: token,
            nameCountry: nameCountry,
            BackEndCode:backEndCode,
            onlyInchcapeRetail:onlyInchcapeRetail,
            utmParams:utmParams
          }"
        > 
        
          <div class="button-container">
            <button mat-raised-button class="desingButton" [ngClass]="styleButton">
              {{ "Scheduler" | translate }}
            </button>
          </div>
        </a>
      </div>
    </div>
    <div class="container-select-query">
      <div class="header-card-op">
        <i class="bi bi-calendar2-date" style="font-size: 40px"></i>
        <div class="text-op">
          <h3>{{ "Consultation" | translate }}</h3>
          <p>{{ "YourDate" | translate }}</p>
        </div>
      </div>
      <div class="banner-content-card">
        <div class="text-description-op">
          <p>{{ "TextConsultationYourDate" | translate }}</p>
        </div>
        <a
          [routerLink]="consultantFormUrl"
          [state]="{
            brand: indexbrand,
            country: indexCountry,
            LanguageForCountry: LanguageForCountry,
            tokenIncadea: token,
            nameCountry: nameCountry,
            BackEndCode:backEndCode,
            onlyInchcapeRetail:onlyInchcapeRetail,
            utmParams:utmParams
          }"
        >
          <div class="button-container">
            <button mat-raised-button class="desingButton" [ngClass]="styleButton" [ngStyle]="button2">
              {{ "Consult" | translate }}
            </button>
          </div>
        </a>
      </div>
    </div>
  </div>
 
</section>

